import { Modal } from "@/components/Modal/Modal";
import { useAppSelector } from "@/hooks/types";
import { UserJobsTable } from "@/pages/UserJobs/UserJobsTable";
import { getIsModalOpen } from "@/store/modal/selectors";
import { ModalTypes } from "@/types/modal";

export const ArchivedJobsModal = () => {
    const isOpen = useAppSelector(getIsModalOpen(ModalTypes.ARCHIVED_JOBS));

    return (
        <Modal
            modalType={ModalTypes.ARCHIVED_JOBS}
            open={isOpen}
            title="Archived Jobs"
            width="5xl"
            mobileFullScreen={true}
        >
            <div className="mx-0 mb-6 flex w-full max-w-6xl flex-col justify-between gap-4  lg:mx-auto lg:mb-12 xl:mb-16">
                <UserJobsTable showArchived={true} />
            </div>
        </Modal>
    );
};
